import { render, staticRenderFns } from "./NavigationTop.vue?vue&type=template&id=8f867ae4&scoped=true"
import script from "./NavigationTop.vue?vue&type=script&lang=js"
export * from "./NavigationTop.vue?vue&type=script&lang=js"
import style0 from "./NavigationTop.vue?vue&type=style&index=0&id=8f867ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f867ae4",
  null
  
)

export default component.exports